export default __webpack_public_path__ + "static/media/bike.2d6146f5.png";